import api from "@/api";
import deepClone from "@/utils/deep-clone";
import { numerically } from "@/utils/sort-object";

const defaultLevel = {
    _id: null,
    name: "",
    active: true,
};

const state = {
    list: [],
    details: {},
};

const getters = {
    list(state) {
        return deepClone(state.list);
    },
    details(state) {
        return id => deepClone(state.details[id] || defaultLevel);
    },
};

const actions = {
    getList({ commit }) {
        return api.get(`/api/teams/get/customRole/list`).then(res => {
            const list = res.data
                .map((element, index) => ({
                    ...element,
                    order: element.order ?? index, // Needed for backward compatibility
                }))
                .sort(numerically("order"));

            commit("updateList", { list });
        });
    },
    get({ commit }, { payload: { id } }) {
        return api.get(`/api/teams/get/customRole/details/${id}`).then(res => {
            const role = res.data || defaultLevel;

            commit("updateDetails", { id, role });
        });
    },
    update({ commit, dispatch, state }, { payload: { level } }) {
        return api.post(`/api/teams/update/customRole`, level).then(res => {
            const role = res.data;

            commit("updateDetails", { id: level._id, role });

            if (level.active) {
                // Refresh list
                return dispatch("getList");
            } else {
                // Level was deleted, update order
                const levels = getters
                    .list(state)
                    .filter(l => l._id !== level._id)
                    .map((l, i) => ({
                        ...l,
                        order: i,
                    }));

                // Note that `updateOrder` already dispatches a new `getList` action
                //
                return dispatch({ type: "updateOrder", payload: { levels } });
            }
        });
    },
    updateOrder({ dispatch }, { payload: { levels } }) {
        if (!levels.length) {
            return dispatch("getList");
        }

        return api.post(`/api/teams/update/customRole/order`, levels).then(() => {
            // Refresh list
            return dispatch("getList");
        });
    },
};

const mutations = {
    updateList(state, { list }) {
        state.list = [...list];
    },
    updateDetails(state, { id, role }) {
        state.details[id] = role;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
